/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@dm/ang';
import { CoreModule } from '@dm/core';

import { DetailCheckResultUpgradeModule } from '../detail-check-result-upgrade/detail-check-result-upgrade.module';
import { UpgradeFileUploadModule } from '../file-upload/file-upload.modules';
import { UpgradeStrService } from '../upgrade-str.service';
import { SystemUpgradeUploadComponent } from './system-upgrade-upload.component';

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        UpgradeFileUploadModule,
        DetailCheckResultUpgradeModule,
    ],
    declarations: [
        SystemUpgradeUploadComponent,
    ],
    providers: [
        SystemUpgradeUploadComponent,
        UpgradeStrService,
    ],
    exports: [SystemUpgradeUploadComponent],
})
export class SystemUpgradeUploadModule { }
